import Link from 'next/link';
import { Box, Card, CardContent, CardMedia, Chip, Typography } from '@mui/material';


// Components
import { DollarToCoin } from '@/common/index';
// Hooks
// import { useIsMobile } from '@/hooks/useIsMobile';
import PlaceholderImage from '@/assets/images/PlaceholderImage';

import { isBlockchainAsset } from '@/utils/products';

export function ProductCard({
  filter,
  product,
  canPurchaseNodes,
  layout,
  hasWallet,
  hasLegacyWallet,
}) {
  const productImg = product?.iconImageURL;
  const isOutOfStock = product?.quantityLimited && product?.quantity <= 0;

  const productUnavailable =
    isOutOfStock || (!product.isAvailableInApp && !canPurchaseNodes);

  const blockChainFlag =
    !hasWallet.hasWallet && !hasWallet.isLoading && isBlockchainAsset(product.productTypeId);

  const imageWidth = layout === 'grid' ? '100%' : '300px';
  const imageHeight = layout === 'grid' ? '400px' : '200px';
  const quantityLow = product?.quantityLimited && +product?.quantity <= 10;

  return (
    <Link
      href={{
        pathname: `/store/${filter}/${product.name}`,
        query: {
          id: product.id,
        },
      }}
      data-core-qa="storeProductsProductCard"
      passHref
    >
      <Card
        sx={{
          display: 'flex',
          flexDirection: layout === 'grid' ? 'column' : 'row',
          position: 'relative',
          cursor: 'pointer',
          padding: '0',
          height: layout === 'grid' ? '350px' : '150px',
        }}
      >
        {productImg ? (
          <CardMedia
            component="img"
            alt="product"
            data-core-qa="storeProductsProductCardImage"
            image={productImg}
            sx={{
              height: imageHeight,
              width: imageWidth,
              objectFit: 'cover',
              objectPosition: 'center',
              overflow: 'hidden',
            }}
          />
        ) : (
          <PlaceholderImage width={imageWidth} height={imageHeight} />
        )}
        {productUnavailable ? (
          <Chip
            size="small"
            label="Unavailable"
            color="error"
            sx={{ top: '16px', left: '16px', position: 'absolute' }}
          />
        ) : (
          blockChainFlag && (
            <Chip
              size="small"
              label={!hasLegacyWallet ? 'Wallet Required' : 'Wallet Upgrade Required'}
              color="info"
              sx={{ top: '16px', left: '16px', position: 'absolute' }}
            />
          )
        )}
        <CardContent
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            height: '100%',
            width: '100%',
          }}
        >
          <Box
            data-core-qa="storeProductsProductTitle"
            sx={{ alignSelf: 'flex-start', display: 'flex', flexDirection: 'column', gap: '8px' }}
          >
            <Typography variant="h4" sx={{ marginBottom: '8px' }}>
              {product.name}
            </Typography>            
            {quantityLow ? isOutOfStock ? <Typography variant="body2" color="error">Sold Out!</Typography> : <Typography variant="body2" color="error" sx={{fontWeight: 'bold'}}>Only {product.quantity} left!</Typography> : null}
          </Box>
          <DollarToCoin dollar={product.price} coin={product.ethPrice} small />
        </CardContent>
      </Card>
    </Link>
  );
}
